import { MAESTRIA_ASSETS } from "./assets";

export interface Cta {
  label: string;
  href: string;
}

export interface FaqItem {
  question: string;
  answer: string;
}

export interface Testimonial {
  name: string;
  company: string;
  quote: string;
  /** Mesmos vídeos do site educacao — o card toca o depoimento, não uma foto. */
  youtubeId: string;
}

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send/?phone=5511987096060&text&type=phone_number&app_absent=0";

/** Mesmo PDF servido no autou.com.br e no educacao. */
export const PRIVACY_HREF = "/privacidade/declaracao-de-privacidade.pdf";

export const MAESTRIA_CONTENT = {
  brand: {
    name: "Maestr.ia",
    logo: MAESTRIA_ASSETS.brand.logo,
    wordmarkGold: MAESTRIA_ASSETS.brand.wordmarkGold,
    autou: MAESTRIA_ASSETS.brand.autou,
    poweredBy: "POWERED BY",
  },
  hero: {
    logoTagline: "Metodologia e estratégia de IA",
    title:
      "Descubra, de forma gratuita, a maior oportunidade de IA escondida\nna sua área e saia com o plano pra transformá-la em resultado",
    titleAccent: "a maior oportunidade de IA",
    tagline: "Clique para garantir sua vaga e virar a referência de IA na sua empresa!",
    taglineAccents: ["virar a referência", "IA"],
    noteImage: MAESTRIA_ASSETS.graphics.rippedNotes,
    noteAlt: "Perfeito para você que não sabe por onde começar!",
    cta: { label: "Entrar na fila de espera", href: "#turma-fundadora" } satisfies Cta,
    videoThumb: MAESTRIA_ASSETS.photos.heroVideo,
    videoThumbAlt: "Workshop AutoU com time em sala de reunião",
    videoId: "T3qBSEl2HMQ", // https://youtu.be/T3qBSEl2HMQ
    // Mesma gravação em corte vertical, pro celular: no widescreen o Edu e o
    // Lucas ficam minúsculos numa tela de 390.
    videoIdVertical: "zkzDl3p9Qo0", // https://youtu.be/zkzDl3p9Qo0
    portrait: MAESTRIA_ASSETS.photos.heroPortrait,
    portraitAlt: "Lucas Fernandes, mentor da Maestr.ia",
    portraitEdu: MAESTRIA_ASSETS.photos.heroPortraitEdu,
    portraitEduAlt: "Eduardo Julianelli, mentor da Maestr.ia",
    ellipses: [
      MAESTRIA_ASSETS.graphics.ellipse1,
      MAESTRIA_ASSETS.graphics.ellipse2,
      MAESTRIA_ASSETS.graphics.ellipse3,
    ],
  },
  ticker: [
    "FEITO PARA GESTORES DE GRANDES EMPRESAS",
    "SEM EXPERIÊNCIA TÉCNICA",
    "SEM DEPENDER DA TI",
  ],
  benefitsTicker: {
    ariaLabel: "Benefícios da imersão",
  },
  partnersTicker: {
    ariaLabel: "Empresas que Eduardo e Lucas já transformaram com IA",
    line1: "EMPRESAS QUE EDUARDO E LUCAS",
    line2: "JÁ TRANSFORMARAM COM IA",
  },
  quickFacts: {
    title: "Entre na fila e receba novidades sobre a próxima turma",
    titleAccent: "próxima turma",
    cta: { label: "Entrar na fila de espera", href: "#atributos" } satisfies Cta,
    cards: [
      {
        title: "Com gravações online",
        icon: MAESTRIA_ASSETS.icons.online,
      },
      {
        title: "Metodologia proprietária",
        icon: MAESTRIA_ASSETS.icons.medal,
      },
    ],
  },
  audience: {
    title: "Para quem é este programa?",
    titleLine1: "Para quem é",
    titleLine2: "este programa?",
    cards: [
      {
        title: "Gestores\nprotagonistas",
        description:
          "Pessoas que querem liderar a\ntransformação de IA dentro\ndas suas empresas.",
        image: MAESTRIA_ASSETS.photos.audience1,
        imageAlt: "Gestor em ambiente corporativo",
      },
      {
        title: "Cansados de resultados rasos",
        description:
          "Pessoas que não querem mais aprender prompts e usar ChatGPT enquanto veem tudo continuar exatamente igual.",
        image: MAESTRIA_ASSETS.photos.audience2,
        imageAlt: "Profissional refletindo sobre resultados",
      },
      {
        title: "Líderes de times\nsobrecarregados",
        description:
          "Pessoas que buscam tirar o\ntime do operacional e liberar\na área pra entregar mais.",
        image: MAESTRIA_ASSETS.photos.audience3,
        imageAlt: "Líder conduzindo equipe",
      },
    ],
  },
  pressure: {
    title: "A verdade sobre a pressão para ",
    titleAccent: '"fazer algo com IA"',
    paragraphs: [
      'Se você vive apagando incêndio na sua área, tendo que entregar tudo em dia e ainda com uma cobrança enorme para "usar IA" na sua empresa, provavelmente já se sentiu sobrecarregado e perdido em meio a tanto hype.',
      "Isso acontece porque você ainda está enxergando a IA como uma ferramenta. Como um ChatGPT ou Copilot. E achando que precisa da direção da TI para utilizar essa tecnologia.",
      "E quando você comete esses erros, é natural que você não veja resultado de verdade da IA no seu trabalho. E que você se sinta perdido e cansado de tanta cobrança.",
      "O que poucas pessoas veem é que o caminho pra resolver essa falta de resultado e sobrecarga pode ser muito mais simples, através da aplicação correta de IA nos seus processos, transformando sua área em AI-First.",
      "E é isso que nós vamos fazer, juntos, na Imersão Maestr.ia.",
    ],
  },
  aiFirst: {
    title: "Por dentro da área AI-First",
    subtitle:
      "Durante a Imersão Maestr.ia você vai descobrir o método que usamos pra transformar áreas de grandes empresas em AI-First, sem precisar programar e sem depender da TI",
    pillars: [
      {
        title: "Fundação",
        description:
          "Organize o conhecimento da sua área pra IA enxergar sua operação em 360º. Seus dados são o seu ouro.",
        icon: MAESTRIA_ASSETS.icons.aiFirst1,
      },
      {
        title: "Sistema",
        description:
          "A IA integrada no dia a dia como inteligência operacional da SUA área, tomando decisões proativas, e não como um chat sem memória.",
        icon: MAESTRIA_ASSETS.icons.aiFirst2,
      },
      {
        title: "Escritório",
        description:
          "Seu time deixa de operar a máquina e passa a projetar como ela funciona. A inteligência é artificial, o protagonismo é humano.",
        icon: MAESTRIA_ASSETS.icons.aiFirst3,
      },
    ],
    note: "A tecnologia é a mesma pra todo mundo. A oportunidade é diferente em cada área.\nA sua, você vai encontrar ao vivo, no nosso ",
    noteAccent: "primeiro encontro.",
    cta: {
      label: "Quero encontrar a oportunidade da minha área",
      href: "#turma-fundadora",
    } satisfies Cta,
  },
  testimonials: {
    title: "Veja o que outras pessoas já alcançaram através do método",
    titleBold: "método",
    icon: MAESTRIA_ASSETS.icons.message,
    items: [
      {
        name: "Rodrigo Guedes",
        company: "Coordenador de Compliance da Prumo",
        quote:
          "Foi uma experiência muito rica, porque reunimos todo o time de auditoria e compliance para discutir algo que está cada vez mais presente no nosso dia a dia: como usar a IA de forma inteligente, responsável e estratégica no nosso trabalho.",
        youtubeId: "dSVKMgdf0XM",
      },
      {
        // O protótipo trazia "Carlos Roberto"; quem fala no vídeo é o Paulo.
        name: "Paulo Carvalho",
        company: "Especialista Senior de RH da Porto do Açu",
        quote:
          "Falar sobre IA dessa forma, trazendo efetivamente a ferramenta, coconstruindo com os consultores da AutoU, com certeza foi diferencial porque trouxe uma ideia mais prática e facilitada do que é, de fato, IA.",
        youtubeId: "Pi_0Y3482-A",
      },
      {
        name: "Iriana Weiss",
        company: "Especialista de RH da Porto do Açu",
        quote:
          "Em um dia olhamos um processo super complexo. Eu queria agradecer na verdade à AutoU pelo suporte e pela parceria.",
        youtubeId: "R0bLBYwTOWg",
      },
      {
        name: "Renata Colares",
        company: "Gerente de Supply Chain da Porto do Açu",
        quote:
          "A gente teve a oportunidade de desafiar os nossos processos, avaliar práticas de mercado e entender as dores dos nossos atuais processos. Daqui é um caminho promissor pra gente conseguir crescer com eficiência e com sustentabilidade.",
        youtubeId: "U7Cb6UMwxTo",
      },
    ] satisfies Testimonial[],
  },
  offer: {
    eyebrow: "O que você recebe na",
    title: "Maestr.ia",
    bonusLabel: "BÔNUS",
    collage: [
      MAESTRIA_ASSETS.photos.offerCollage1,
      MAESTRIA_ASSETS.photos.offerCollage2,
      MAESTRIA_ASSETS.photos.offerCollage3,
    ],
    items: [
      {
        title: "Método completo da Área AI-First",
        titleAccent: "AI-First",
        description:
          "Domine a metodologia proprietária da Maestr.ia para transformar sua área em uma operação AI-First. Um framework prático para identificar oportunidades, priorizar iniciativas e implementar IA com foco em resultado.",
        note: "Framework prático e pronto\npara aplicar na sua\nempresa!",
      },
      {
        title: "Plano personalizado de estratégia de IA da sua área",
        titleAccent: "estratégia de IA",
        description:
          "Desenvolva um plano exclusivo para a realidade da sua equipe. Ao final da imersão, você sai com um roadmap claro, priorizado e pronto para colocar em prática.",
        image: MAESTRIA_ASSETS.photos.offerPlano,
        imageAlt: "Plano personalizado de estratégia",
        caption: "* Imagem ilustrativa",
        note: "Feito para a realidade da\nsua equipe.",
      },
      {
        title: "Agente Maestr.ia",
        titleAccent: "Maestr.ia",
        description:
          "Tenha acesso a um agente de IA treinado na metodologia da Maestr.ia para apoiar sua implementação. Ele ajuda a tirar dúvidas, evoluir sua estratégia e acelerar a adoção da IA na sua área.",
        image: MAESTRIA_ASSETS.photos.offerAgente,
        imageAlt: "Interface do Agente Maestr.ia",
        caption: "* Imagem ilustrativa",
        note: "Seu copiloto de IA após a\nimersão!",
      },
    ],
  },
  beforeAfter: {
    beforeTitle: "Antes da Imersão",
    afterTitle: "Depois da Imersão",
    srTitle: "Antes e depois da Imersão",
    before: [
      "Cobrança pra usar IA e nenhuma resposta pronta",
      "Time afogado em planilha e retrabalho",
      "Boas ideias morrendo no papel",
      "Usando ChatGPT e Copilot sem ver resultado de verdade",
      "Vendo outras áreas e colegas saírem na frente",
    ],
    after: [
      "A maior oportunidade de IA da sua área, identificada",
      "Clareza de onde a IA libera o seu time primeiro",
      "Um plano de 1 página com número, pronto pra apresentar",
      "Um método de quem implementa, aplicado no seu processo",
      "Você conduzindo a conversa de IA na sua empresa",
    ],
    decor: [MAESTRIA_ASSETS.photos.beforeAfter1, MAESTRIA_ASSETS.photos.beforeAfter2],
  },
  deliverables: {
    title: "Recapitulando o que você vai receber",
    cards: [
      {
        title: "Encontros ao vivo com os fundadores da AutoU",
        description:
          "Dois encontros ao vivo de 1h30 cada, imersos no processo da sua própria área, com espaço para perguntas. Não é aula gravada nem exemplo genérico. A data da próxima turma ainda não está fechada: quem entra na fila de espera recebe a novidade primeiro.",
      },
      {
        title: "O mapa da Área AI-First!",
        description:
          "Os 3 eixos que usamos para transformar áreas de grandes empresas, explicados sem tecniquês, para você enxergar o caminho completo.",
      },
      {
        title: "O template do Plano de uma página",
        description:
          "O mesmo racional dos nossos business cases reais. Você sai da imersão com o seu preenchido, pronto pra apresentar.",
      },
      {
        title: "Replay dos 2 encontros",
        description: "Acesso por 14 dias. Se o dia sair do controle, você não perde nada.",
      },
    ],
    bonus: {
      title: "Agente Maestr.ia",
      description:
        "Um agente treinado no nosso método, disponível da sua inscrição até depois do último encontro. Antes do Encontro 1, ele te ajuda a escolher o processo certo da sua área. Depois, aperta o seu plano com você até ficar pronto pra apresentar.",
      icon: MAESTRIA_ASSETS.photos.deliverablesAgent,
    },
    note: "Quando uma empresa contrata a AutoU pra fazer esse diagnóstico por ela, o projeto custa dezenas de milhares de reais. \nNa imersão, você aprende a conduzir o primeiro passo com as próprias mãos.",
  },
  founderClass: {
    eyebrow: "A primeira turma será gratuita, por convite.",
    eyebrowStrong: "será gratuita,",
    title: "Turma Fundadora",
    price: "Gratuito para convidados selecionados pela AutoU",
    columns: [
      "Após implementarmos 250+ soluções digitais em grandes empresas, estamos lançando nosso formato digital para democratizar o acesso ao nosso método.",
      "Queremos a turma fundadora com os gestores certos, construindo junto e dando feedback de verdade.",
      "Em troca do seu ingresso, pedimos duas coisas: presença ao vivo nos 2 encontros e sua opinião sincera.",
    ],
    columnStrong: "turma fundadora",
    limited: "Vagas limitadas a 50 participantes, com aprovação caso a caso.",
    limitedStrong: "Vagas limitadas",
    ticket: MAESTRIA_ASSETS.graphics.ticketTurma,
    cta: {
      label: "Garantir minha vaga na turma fundadora",
      href: "#turma-fundadora",
    } satisfies Cta,
  },
  mentors: {
    title: "Quem serão seus mentores?",
    bio: "Juntos, já lideramos mais de 250 implementações para 40+ clientes enterprise, entre eles Nestlé, L'Oréal, Stellantis, B3, Jaguar Land Rover e Saint-Gobain, impactando 150 mil usuários em 15+ países e gerando mais de R$60 milhões em ganhos mensuráveis para nossos clientes.",
    items: [
      {
        name: "Eduardo Julianelli",
        role: "Sócio-fundador da AutoU",
        image: MAESTRIA_ASSETS.photos.mentorEduardo,
        imageAlt: "Retrato de Eduardo Julianelli",
        backdrop: MAESTRIA_ASSETS.photos.mentorEduardoBg,
        bio: "Engenheiro de produção com +10 anos como consultor de transformação digital nas maiores empresas do mundo. Professor de programação aplicada a negócios. Transformo operações de alta complexidade com tecnologia e IA.",
      },
      {
        name: "Lucas Fernandes",
        role: "Sócio-fundador da AutoU",
        image: MAESTRIA_ASSETS.photos.mentorLucas,
        imageAlt: "Retrato de Lucas Fernandes",
        backdrop: MAESTRIA_ASSETS.photos.mentorLucasBg,
        bio: "Programo desde os 14 anos e trabalho há 12+ anos no mundo corporativo. Especialização em Data Science & Machine Learning pelo MIT e em Business & Finanças pelo IESE Barcelona. Vivo dentro de grandes empresas aplicando tecnologia para impulsionar resultados.",
      },
    ],
  },
  faq: {
    // quebra de linha do Figma; "frequentes" vai em SemiBold
    title: "Perguntas\nfrequentes",
    items: [
      {
        question: "Preciso saber programar ou entender de tecnologia?",
        answer:
          "Não. O método foi feito pra quem lidera o negócio. A tecnologia é o motor, quem dirige é você.",
      },
      {
        question: "Serve pra minha área?",
        answer:
          "Se a sua área tem processo pesado, com planilha, retrabalho e tarefa manual, serve. Já aplicamos essa lógica em operações, finanças, qualidade, suprimentos, RH e dezenas de outras frentes.",
      },
      {
        question: "Preciso trabalhar numa empresa grande?",
        answer:
          "Sim, nossa metodologia é especializada em empresas grandes e multinacionais. Se sua empresa tem 200+ funcionários, já consideramos uma empresa grande o suficiente.",
      },
      {
        question: "Preciso ser gestor/líder de uma área?",
        answer:
          "Nossa metodologia é focada em gestores protagonistas de empresas grandes, que possam liderar a transformação com IA nas suas empresas. Se você fizer parte de um time com algumas pessoas e já tiver influência no time e na sua área, você pode participar e se beneficiar muito da metodologia.",
      },
      {
        question: "Quanto tempo isso vai exigir de mim?",
        answer:
          "3 horas de imersão ao vivo, em dois encontros de 1h30, das 17h às 18h30. Antes, você conversa por alguns minutos com o Agente Maestr.ia para preparar sua área.",
      },
      {
        question: "Por que a turma fundadora é gratuita?",
        answer:
          "Estamos lançando o formato digital do nosso método e queremos a primeira turma com os gestores certos, nos dando feedback de verdade. As próximas turmas serão pagas.",
      },
      {
        question: "Vai ter venda de alguma coisa no final?",
        answer:
          "Vamos mostrar, com transparência, como a AutoU pode ajudar quem quiser ir além do plano. Sem pressão e sem pegadinha. O conteúdo da imersão se sustenta sozinho.",
      },
      {
        question: "E se eu não puder assistir ao vivo?",
        answer:
          "Os encontros ficam gravados por 14 dias. Mas a vaga da turma fundadora é pra quem vai estar presente, essa é a contrapartida do convite.",
      },
      {
        question: "Preciso preparar algo antes do Encontro 1?",
        answer:
          "Só uma conversa de alguns minutos com o Agente Maestr.ia, que vai te ajudar a escolher o processo da sua área que você vai trabalhar na imersão.",
      },
      {
        question: "Como funciona a aprovação da vaga?",
        answer:
          "Você se inscreve, a gente analisa caso a caso e confirma sua vaga por e-mail e WhatsApp.",
      },
    ] satisfies FaqItem[],
  },
  whatsAppHelp: {
    title: "Precisa de alguma ajuda?",
    description: "Estamos prontos para te ajudar! É só clicar no botão abaixo e falar com o Lucas.",
    cta: { label: "Falar com o Lucas", href: WHATSAPP_HREF } satisfies Cta,
  },
  footer: {
    copyright: "© Maestr.ia · AutoU. Todos os direitos reservados.",
    privacy: { label: "Declaração de privacidade", href: PRIVACY_HREF } satisfies Cta,
    preferences: "Preferencias de privacidade",
  },
  signup: {
    title: "Insira suas informações aqui e garanta sua vaga na Imersão Maestr.ia.",
    fields: {
      name: "Nome*",
      phone: "WhatsApp",
      email: "E-mail corporativo*",
      company: "Empresa*",
      role: "Cargo*",
    },
    submit: "Garantir minha vaga",
    submitting: "Enviando...",
    error: "Não conseguimos enviar agora. Tente novamente em instantes.",
    privacy: {
      lead: "Ao enviar, você concorda com a nossa ",
      link: { label: "declaração de privacidade", href: PRIVACY_HREF } satisfies Cta,
    },
    qualification: {
      text: "Confirmo que trabalho em uma empresa grande e estou ciente de que esta vaga é exclusiva para esse perfil.",
      strong: "empresa grande",
      note: "As inscrições que não atenderem a esse critério poderão ser desconsideradas.",
    },
    close: "Fechar",
    success: {
      image: MAESTRIA_ASSETS.graphics.signupSuccess,
      imageAlt: "",
      title: "Obrigado pelo seu interesse em participar da nossa Imersão Maestr.ia.",
      description:
        "Em alguns dias, iremos te dar um retorno na sua caixa de e-mail ou WhatsApp.",
    },
  },
} as const;

type DeepString<T> = T extends string
  ? string
  : T extends readonly [infer Head, ...infer Tail]
    ? readonly [DeepString<Head>, ...DeepString<Tail>]
    : T extends readonly []
      ? readonly []
      : T extends readonly (infer U)[]
        ? readonly DeepString<U>[]
        : T extends object
          ? { readonly [K in keyof T]: DeepString<T[K]> }
          : T;

export type MaestriaContent = DeepString<typeof MAESTRIA_CONTENT>;

export const MAESTRIA_CONTENT_EN: MaestriaContent = {
  brand: {
    name: "Maestr.ia",
    logo: MAESTRIA_ASSETS.brand.logo,
    wordmarkGold: MAESTRIA_ASSETS.brand.wordmarkGold,
    autou: MAESTRIA_ASSETS.brand.autou,
    poweredBy: "POWERED BY",
  },
  hero: {
    logoTagline: "AI methodology and strategy",
    title:
      "Discover, for free, the biggest hidden AI opportunity\nin your department and leave with the plan to turn it into results",
    titleAccent: "the biggest hidden AI opportunity",
    tagline: "Click to secure your spot and become the AI benchmark at your company!",
    taglineAccents: ["become the AI benchmark", "AI"],
    noteImage: MAESTRIA_ASSETS.graphics.rippedNotes,
    noteAlt: "Perfect for anyone who doesn't know where to start!",
    cta: { label: "Join the waitlist", href: "#turma-fundadora" } satisfies Cta,
    videoThumb: MAESTRIA_ASSETS.photos.heroVideo,
    videoThumbAlt: "AutoU workshop with team in meeting room",
    videoId: "T3qBSEl2HMQ",
    videoIdVertical: "zkzDl3p9Qo0",
    portrait: MAESTRIA_ASSETS.photos.heroPortrait,
    portraitAlt: "Lucas Fernandes, mentor at Maestr.ia",
    portraitEdu: MAESTRIA_ASSETS.photos.heroPortraitEdu,
    portraitEduAlt: "Eduardo Julianelli, mentor at Maestr.ia",
    ellipses: [
      MAESTRIA_ASSETS.graphics.ellipse1,
      MAESTRIA_ASSETS.graphics.ellipse2,
      MAESTRIA_ASSETS.graphics.ellipse3,
    ],
  },
  ticker: [
    "BUILT FOR ENTERPRISE LEADERS",
    "NO TECHNICAL BACKGROUND REQUIRED",
    "NO IT DEPENDENCY",
  ],
  benefitsTicker: {
    ariaLabel: "Immersion benefits",
  },
  partnersTicker: {
    ariaLabel: "Companies that Eduardo and Lucas have already transformed with AI",
    line1: "COMPANIES THAT EDUARDO AND LUCAS",
    line2: "HAVE ALREADY TRANSFORMED WITH AI",
  },
  quickFacts: {
    title: "Join the waitlist and get updates on the upcoming cohort",
    titleAccent: "upcoming cohort",
    cta: { label: "Join the waitlist", href: "#atributos" } satisfies Cta,
    cards: [
      {
        title: "Online recordings included",
        icon: MAESTRIA_ASSETS.icons.online,
      },
      {
        title: "Proprietary methodology",
        icon: MAESTRIA_ASSETS.icons.medal,
      },
    ],
  },
  audience: {
    title: "Who is this program for?",
    titleLine1: "Who is this",
    titleLine2: "program for?",
    cards: [
      {
        title: "Proactive\nmanagers",
        description:
          "Leaders eager to spearhead the\nAI transformation within\ntheir organizations.",
        image: MAESTRIA_ASSETS.photos.audience1,
        imageAlt: "Manager in corporate environment",
      },
      {
        title: "Tired of shallow results",
        description:
          "Professionals done with collecting prompts and using ChatGPT while daily operations remain unchanged.",
        image: MAESTRIA_ASSETS.photos.audience2,
        imageAlt: "Professional reflecting on results",
      },
      {
        title: "Leaders of\noverwhelmed teams",
        description:
          "Leaders looking to pull their\nteam out of manual tasks and\nfree up bandwidth for higher impact.",
        image: MAESTRIA_ASSETS.photos.audience3,
        imageAlt: "Leader directing team",
      },
    ],
  },
  pressure: {
    title: "The truth about the pressure to ",
    titleAccent: '"do something with AI"',
    paragraphs: [
      'If you spend your days putting out fires in your department, racing to meet deadlines under intense pressure to "use AI" at your company, you have likely felt overwhelmed and lost amid all the hype.',
      "This happens because you are still viewing AI merely as a tool, like ChatGPT or Copilot, and assuming you must wait on IT leadership to adopt this technology.",
      "When these missteps occur, it is only natural that you don't see tangible AI results in your workflow, leaving you feeling frustrated and worn out by constant demands.",
      "What few realize is that the path to eliminating bottlenecks and driving actual impact can be far simpler: applying AI purposefully to your core processes to build an AI-First department.",
      "And that is exactly what we will do together in the Maestr.ia Immersion.",
    ],
  },
  aiFirst: {
    title: "Inside the AI-First department",
    subtitle:
      "During the Maestr.ia Immersion, you will discover the method we use to turn enterprise business units into AI-First departments—without coding and without depending on IT",
    pillars: [
      {
        title: "Foundation",
        description:
          "Structure your department's domain knowledge so AI gains a 360º view of operations. Your proprietary data is your gold.",
        icon: MAESTRIA_ASSETS.icons.aiFirst1,
      },
      {
        title: "System",
        description:
          "AI integrated into daily operations as the operational intelligence of YOUR business unit, taking proactive decisions instead of acting as a stateless chatbot.",
        icon: MAESTRIA_ASSETS.icons.aiFirst2,
      },
      {
        title: "Workspace",
        description:
          "Your team stops manual execution and starts orchestrating how the system runs. The intelligence is artificial; the leadership is human.",
        icon: MAESTRIA_ASSETS.icons.aiFirst3,
      },
    ],
    note: "The underlying technology is the same for everyone. The opportunity is unique to each department.\nYours, you will uncover live in our ",
    noteAccent: "first live session.",
    cta: {
      label: "I want to uncover my department's opportunity",
      href: "#turma-fundadora",
    } satisfies Cta,
  },
  testimonials: {
    title: "See what others have achieved through the method",
    titleBold: "method",
    icon: MAESTRIA_ASSETS.icons.message,
    items: [
      {
        name: "Rodrigo Guedes",
        company: "Coordenador de Compliance da Prumo",
        quote:
          "It was a very enriching experience, bringing together the entire audit and compliance team to discuss something increasingly vital to our routine: using AI intelligently, responsibly, and strategically in our work.",
        youtubeId: "dSVKMgdf0XM",
      },
      {
        name: "Paulo Carvalho",
        company: "Especialista Senior de RH da Porto do Açu",
        quote:
          "Discussing AI this way, practically deploying the tools and co-building alongside AutoU consultants, was truly distinctive because it offered a hands-on, accessible perspective of what AI really delivers.",
        youtubeId: "Pi_0Y3482-A",
      },
      {
        name: "Iriana Weiss",
        company: "Especialista de RH da Porto do Açu",
        quote:
          "In just one day we mapped out a highly complex process. I truly want to thank AutoU for their support and trusted partnership.",
        youtubeId: "R0bLBYwTOWg",
      },
      {
        name: "Renata Colares",
        company: "Gerente de Supply Chain da Porto do Açu",
        quote:
          "We had the opportunity to challenge our workflows, evaluate industry best practices, and address existing bottlenecks. This opens a promising path to scaling with efficiency and sustainability.",
        youtubeId: "U7Cb6UMwxTo",
      },
    ] satisfies Testimonial[],
  },
  offer: {
    eyebrow: "What you receive in",
    title: "Maestr.ia",
    bonusLabel: "BONUS",
    collage: [
      MAESTRIA_ASSETS.photos.offerCollage1,
      MAESTRIA_ASSETS.photos.offerCollage2,
      MAESTRIA_ASSETS.photos.offerCollage3,
    ],
    items: [
      {
        title: "Full AI-First Department Framework",
        titleAccent: "AI-First",
        description:
          "Master Maestr.ia's proprietary methodology to turn your department into an AI-First operation. A practical framework to uncover opportunities, prioritize initiatives, and deploy AI focused on measurable ROI.",
        note: "Practical framework ready\nto deploy in your\ncompany!",
      },
      {
        title: "Personalized AI Strategy Roadmap for your department",
        titleAccent: "AI Strategy Roadmap",
        description:
          "Develop an actionable plan tailored specifically to your team's day-to-day reality. By the end of the immersion, you walk away with a clear, prioritized roadmap ready for execution.",
        image: MAESTRIA_ASSETS.photos.offerPlano,
        imageAlt: "Tailored strategic plan",
        caption: "* Illustrative image",
        note: "Customized for your\nteam's reality.",
      },
      {
        title: "Maestr.ia AI Agent",
        titleAccent: "Maestr.ia",
        description:
          "Get direct access to an AI agent trained on the Maestr.ia methodology to support your rollout. It answers questions, refines your strategy, and accelerates AI adoption across your department.",
        image: MAESTRIA_ASSETS.photos.offerAgente,
        imageAlt: "Maestr.ia Agent Interface",
        caption: "* Illustrative image",
        note: "Your AI co-pilot after\nthe immersion!",
      },
    ],
  },
  beforeAfter: {
    beforeTitle: "Before the Immersion",
    afterTitle: "After the Immersion",
    srTitle: "Before and after the Immersion",
    before: [
      "Constant pressure to use AI with no clear direction",
      "Team buried in spreadsheets and manual rework",
      "Strong ideas stalled on the drawing board",
      "Using ChatGPT and Copilot without tangible ROI",
      "Watching competing departments pull ahead",
    ],
    after: [
      "Your department's highest-value AI opportunity identified",
      "Total clarity on where AI unlocks immediate team capacity",
      "A one-page, data-backed plan ready to pitch to leadership",
      "A proven practitioner methodology applied to your workflows",
      "You driving the strategic AI conversation across your company",
    ],
    decor: [MAESTRIA_ASSETS.photos.beforeAfter1, MAESTRIA_ASSETS.photos.beforeAfter2],
  },
  deliverables: {
    title: "Recapping what you will receive",
    cards: [
      {
        title: "Live sessions with the founders of AutoU",
        description:
          "Two 90-minute live sessions diving directly into your department's workflows, with open Q&A. No pre-recorded lectures or generic theory. Upcoming cohort dates are being finalized: waitlist members receive early access.",
      },
      {
        title: "The AI-First Department Blueprint!",
        description:
          "The 3 core pillars we use to transform enterprise business units, delivered without technical jargon so you see the complete picture.",
      },
      {
        title: "The One-Page Plan Template",
        description:
          "The exact framework from our real-world enterprise business cases. You leave the immersion with your plan completed, ready to present.",
      },
      {
        title: "Full recordings of both sessions",
        description: "14-day on-demand access. If urgent business comes up, you won't miss a beat.",
      },
    ],
    bonus: {
      title: "Maestr.ia AI Agent",
      description:
        "An AI agent trained on our proprietary framework, accessible from sign-up through after the final session. Before Session 1, it helps you identify the ideal process in your area. Afterwards, it stress-tests your plan until it is boardroom-ready.",
      icon: MAESTRIA_ASSETS.photos.deliverablesAgent,
    },
    note: "When an enterprise hires AutoU to run this diagnostic, projects run into tens of thousands of Brazilian reais.\nIn this immersion, you master leading that transformation firsthand.",
  },
  founderClass: {
    eyebrow: "The founding cohort will be free, by invitation.",
    eyebrowStrong: "will be free,",
    title: "Founding Cohort",
    price: "Free for invited leaders selected by AutoU",
    columns: [
      "After delivering 250+ digital solutions across Fortune 500 & enterprise leaders, we are launching this interactive digital format to scale access to our method.",
      "We are building our founding cohort with the right leaders to co-create and provide unfiltered feedback.",
      "In exchange for your invitation, we ask for two commitments: live attendance across both sessions and your candid feedback.",
    ],
    columnStrong: "founding cohort",
    limited: "Limited spots capped at 50 leaders, approved on a rolling basis.",
    limitedStrong: "Limited spots",
    ticket: MAESTRIA_ASSETS.graphics.ticketTurma,
    cta: {
      label: "Secure my spot in the founding cohort",
      href: "#turma-fundadora",
    } satisfies Cta,
  },
  mentors: {
    title: "Who will your mentors be?",
    bio: "Together, we have led over 250 enterprise implementations for 40+ corporate clients—including Nestlé, L'Oréal, Stellantis, B3, Jaguar Land Rover, and Saint-Gobain—impacting 150,000+ users across 15+ countries and generating over $12M+ (R$60M+) in measurable business value.",
    items: [
      {
        name: "Eduardo Julianelli",
        role: "Co-founder at AutoU",
        image: MAESTRIA_ASSETS.photos.mentorEduardo,
        imageAlt: "Portrait of Eduardo Julianelli",
        backdrop: MAESTRIA_ASSETS.photos.mentorEduardoBg,
        bio: "Industrial engineer with 10+ years consulting on digital transformation for global enterprises. Lecturer in applied business programming. Transforming high-complexity operations through modern tech and AI.",
      },
      {
        name: "Lucas Fernandes",
        role: "Co-founder at AutoU",
        image: MAESTRIA_ASSETS.photos.mentorLucas,
        imageAlt: "Portrait of Lucas Fernandes",
        backdrop: MAESTRIA_ASSETS.photos.mentorLucasBg,
        bio: "Coding since age 14 with 12+ years in corporate enterprise. Specialized in Data Science & Machine Learning at MIT and Business & Finance at IESE Barcelona. Partnering inside large corporations applying technology to drive bottom-line results.",
      },
    ],
  },
  faq: {
    title: "Frequently\nasked questions",
    items: [
      {
        question: "Do I need coding skills or a technical background?",
        answer:
          "No. The method is designed specifically for business and operational leaders. Technology is the engine; you are the driver.",
      },
      {
        question: "Does this apply to my specific department?",
        answer:
          "If your area handles high-volume workflows, spreadsheets, repetitive tasks, and manual handoffs, absolutely. We have deployed this framework across operations, finance, quality assurance, procurement, HR, and dozens of other functions.",
      },
      {
        question: "Do I need to work at a large enterprise?",
        answer:
          "Yes. Our methodology is built specifically for mid-to-large enterprises and multinational corporations. Companies with 200+ employees meet our target threshold.",
      },
      {
        question: "Do I need to be a department head or manager?",
        answer:
          "Our framework centers on proactive leaders and managers positioned to champion AI initiatives. If you lead or hold key influence within a team and department, you can participate and gain substantial value from the program.",
      },
      {
        question: "How much time commitment is required?",
        answer:
          "3 hours of live immersion across two 90-minute sessions, from 5:00 to 6:30 PM (Brasília time). Prior to the first meeting, you will spend a few minutes with the Maestr.ia AI Agent to prepare your focus area.",
      },
      {
        question: "Why is the founding cohort free of charge?",
        answer:
          "We are introducing the digital format of our enterprise framework and want the initial group composed of engaged leaders providing actionable feedback. Future cohorts will be fully paid.",
      },
      {
        question: "Will there be a sales pitch at the end?",
        answer:
          "We will transparently outline how AutoU can partner with leaders looking to accelerate implementation beyond their initial plan. No pressure, no gimmicks. The immersion content stands entirely on its own.",
      },
      {
        question: "What if I cannot attend live?",
        answer:
          "Recordings remain accessible for 14 days. However, founding cohort seats are reserved for participants committed to live attendance—that is the commitment behind the complimentary invite.",
      },
      {
        question: "Do I need to prepare anything before Session 1?",
        answer:
          "Just a brief interaction with the Maestr.ia AI Agent, which helps pinpoint the exact operational process you will work on during the immersion.",
      },
      {
        question: "How does the admission approval work?",
        answer:
          "You apply, our team reviews each profile individually, and confirms your admission via email and WhatsApp.",
      },
    ] satisfies FaqItem[],
  },
  whatsAppHelp: {
    title: "Need any help?",
    description: "We are here to assist! Just click the button below to message Lucas directly.",
    cta: { label: "Message Lucas", href: WHATSAPP_HREF } satisfies Cta,
  },
  footer: {
    copyright: "© Maestr.ia · AutoU. All rights reserved.",
    privacy: { label: "Privacy Notice", href: PRIVACY_HREF } satisfies Cta,
    preferences: "Privacy preferences",
  },
  signup: {
    title: "Enter your information below to secure your spot in the Maestr.ia Immersion.",
    fields: {
      name: "Full Name*",
      phone: "WhatsApp",
      email: "Corporate Email*",
      company: "Company*",
      role: "Job Title*",
    },
    submit: "Secure my spot",
    submitting: "Submitting...",
    error: "Could not submit right now. Please try again in a moment.",
    privacy: {
      lead: "By submitting, you agree to our ",
      link: { label: "privacy notice", href: PRIVACY_HREF } satisfies Cta,
    },
    qualification: {
      text: "I confirm that I work at a large company and I am aware that this spot is exclusive to this profile.",
      strong: "large company",
      note: "Applications that do not meet this criterion may be disregarded.",
    },
    close: "Close",
    success: {
      image: MAESTRIA_ASSETS.graphics.signupSuccess,
      imageAlt: "",
      title: "Thank you for your interest in joining the Maestr.ia Immersion.",
      description:
        "Our team will reach out within a few business days via email or WhatsApp.",
    },
  },
} as const;

export function getMaestriaContent(locale: "pt" | "en"): MaestriaContent {
  return locale === "en" ? MAESTRIA_CONTENT_EN : MAESTRIA_CONTENT;
}
